export const getShortDate = (date: Date) =>
  new Date(date)
    .toLocaleDateString("default", {
      // day: "numeric",
      month: "short",
      year: "numeric",
    })
    .toLocaleLowerCase();
